import { Link } from 'react-router-dom';
import appointDocLogo from '../assets/appointdoc-logo-access.png';

export default function AuthOptions() {
  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center p-4 bg-gray-50/50">
      <div className="w-full max-w-[400px]">
        <div className="text-center">
          <Link to="/">
            <img
              src={appointDocLogo}
              alt="AppointDoc"
              className="w-32 h-auto mx-auto mb-4"
            />
          </Link>
        </div>

        <div className="border border-gray-300 rounded-2xl p-8 bg-white">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold mb-2">
              Log in or sign up in seconds
            </h1>
            <p className="text-sm text-muted-foreground">
              Login or create an account to get started
            </p>
          </div>

          <div className="flex gap-4">
            <Link
              to="/login"
              className="flex-1 btn bg-primary-500 hover:bg-primary-600 text-white h-12"
            >
              I have an account
            </Link>
            <Link to="/signup" className="flex-1 btn btn-outline h-12">
              I'm new here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
